import extracts from './vi-VN/extract.json';
import menu from './vi-VN/menu.json';
import pwa from './vi-VN/pwa.json';

export default {
  'navBar.lang': 'Ngôn ngữ',
  'layout.user.link.help': 'Trợ giúp',
  'layout.user.link.privacy': 'Riêng tư',
  'layout.user.link.terms': 'Điều khoản',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  'loginForm.submitText': 'Đăng nhập',
  ...menu,
  ...pwa,
  ...extracts,
};
